module.exports = __webpack_public_path__ + "img/suffle.15107049.svg";